// extracted by mini-css-extract-plugin
export default {"wrapper":"layout-module--wrapper--5ec98"};